import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { RiskConfig } from './types'

interface RiskBannerProps {
    risk: RiskConfig
    percentUsed: number
    outstandingAmount: number
    creditLimit: number
    available: number
    fmt: (n: number) => string
}

export default function RiskBanner({ risk, percentUsed, outstandingAmount, creditLimit, available, fmt }: RiskBannerProps) {
    console.log(percentUsed)
    return (
        <>
            <div className={`rounded-xl border p-3.5 ${risk.panelBg} ${risk.panelBorder}`}>
                <div className="flex items-center justify-between mb-3">
                    <p className={`text-[12.5px] font-semibold ${risk.panelHeadingText}`}>{risk.panelHeading}</p>
                    <span className={`text-[11px] font-semibold ${risk.panelHeadingText}`}>{percentUsed.toFixed(0)}% used</span>
                </div>
                <div className="space-y-1.5 text-[13px]">
                    <div className="flex justify-between text-slate-600">
                        <span>Current outstanding</span>
                        <span className="text-slate-900 font-medium">{fmt(outstandingAmount)}</span>
                    </div>
                    <div className={`h-px my-1.5 ${risk.dividerColor}`} />
                    <div className="flex justify-between text-slate-600">
                        <span>Credit limit</span>
                        <span className="text-slate-900 font-medium">{fmt(creditLimit)}</span>
                    </div>
                    <div className="flex justify-between text-slate-600">
                        <span>Available credit</span>
                        <span className="text-emerald-600 font-semibold">{fmt(available)}</span>
                    </div>
                </div>
            </div>

            {risk.showApprovalWarning && (
                <div className="flex items-start gap-2 rounded-xl bg-amber-50 border border-amber-100 px-3.5 py-2.5">
                    <AlertTriangle size={15} className="text-amber-500 mt-0.5 shrink-0" strokeWidth={2} />
                    <p className="text-[12.5px] text-amber-800 leading-snug">Admin approval is required to proceed with this order.</p>
                </div>
            )}
        </>
    )
}
